var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlipp = function SvgBlipp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 14.4V3.264C19.2 1.44 18.24 0 16.32 0C14.4 0 12.48 1.44 12.48 3.264V14.4H9.6C4.32 14.4 0 18.24 0 24C0 28.8 4.32 33.6 9.6 33.6C15.36 33.6 19.2 28.8 19.2 24V21.12C24 22.08 27.84 25.92 27.84 30.72C27.84 36.48 23.04 41.28 17.28 41.28H7.296C5.472 41.28 4.032 43.2 4.032 44.16C4.032 46.08 5.472 48 7.296 48H17.28C26.88 48 33.6 40.32 33.6 30.72C33.6 22.08 27.84 15.36 19.2 14.4ZM12.48 24C12.48 25.92 11.52 26.88 9.6 26.88C7.968 26.88 6.624 25.92 6.624 24C6.624 22.08 7.968 21.12 9.6 21.12H12.48V24Z",
    fill: "#000033"
  })));
};
export default SvgBlipp;